import React from 'react'
import { Box, ButtonGroup, Typography } from "@material-ui/core"
import RegularButton from "components/CustomButtons/Button"
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { ModalV2 } from 'components/Modal/ModalV2';
import { useToggle } from 'hooks/useToggle';
import { useDispatch } from 'react-redux';
import { deleteContidion } from 'redux/actions/conditionsCatalog/conditionsCatalog';
import { NewFormCondition } from './NewFormCondition';

const colors = {
    success: '#4caf50',
    error: '#f6685e',
    info: '#4092E5'
}

export const columns = [
    {
        Header: "nombre",
        accessor: "label",
        filterable: true,
        filterMethod: (filter, row) => {
            return row.label.toLowerCase().includes(filter.value.toLowerCase())
        }
    },
    {
        Header: "Unidad Metrica",
        accessor: "metricUnit",
        filterable: true,
        filterMethod: (filter, row) => { return row.label.toLowerCase().includes(filter.value.toLowerCase()) }
    },
    {
        Header: "Esta limitado a 1?",
        filterable: true,
        filterMethod: (filter, row) => { return row.label.toLowerCase().includes(filter.value.toLowerCase()) },
        Cell: ({ original }) => (<span>{original.limited ? 'Si' : 'No'}</span>)
    },
    {
        Header: "Acciones",
        Cell: ({ original }) => {
            const [open, handleOpen] = useToggle()
            const [confirm, setConfirm] = useToggle()
            const dispatch = useDispatch()

            const handleDelete = () => {
                dispatch(deleteContidion(original.value))
                setConfirm()
            }
            return (
                <>
                    <ButtonGroup style={{
                        float: 'right'
                    }}>
                        <RegularButton round justIcon color="transparent" size="sm" tooltip="editar" onClick={handleOpen}>
                            <EditIcon style={{
                                color: colors.info
                            }} />
                        </RegularButton>
                        <RegularButton round justIcon color="transparent" size="sm" tooltip="eliminar" onClick={setConfirm}>
                            <DeleteIcon style={{
                                color: colors.error
                            }} />
                        </RegularButton>
                    </ButtonGroup>
                    <ModalV2
                        open={open}
                        onClose={handleOpen}
                        title='Editar Condición'
                    >
                        <NewFormCondition edit close={handleOpen} condition={original} />
                    </ModalV2>
                    <ModalV2
                        open={confirm}
                        onClose={setConfirm}
                        title='Eliminar'
                    >
                        <Typography variant="subtitle2" align='center'>Estas seguro que desea eliminar <span style={{
                            color: colors.error
                        }}> {original.label}</span> </Typography>
                        <Box style={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            gap: 16,
                            marginTop: 20
                        }}>

                            <RegularButton color="error" onClick={setConfirm}>Cancelar</RegularButton>
                            <RegularButton color="info" onClick={handleDelete}>Confirmar</RegularButton>
                        </Box>
                    </ModalV2>
                </>
            )
        }
    }]